var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"back-button",attrs:{"to":{name: _vm.to, params: _vm.params}}},[_vm._v(_vm._s(_vm.title)),_c('i',{staticClass:"icon icon--back"})])
}
var staticRenderFns = []

export { render, staticRenderFns }